<div class="row filters-wrapper">
  <div class="col-auto">
    <mat-form-field class="d-block filter-ctrl">
      <mat-select placeholder="Type" [formControl]="filters.get('type')">
        <mat-option value="all">All</mat-option>
        <mat-option value="pct">Percent</mat-option>
        <mat-option value="flat">Flat</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="col-auto">
    <app-select-search
      class="filter-ctrl"
      floatLabel="never"
      bindValue="id"
      bindLabel="name"
      [multiple]="true"
      [items]="rentals$ | async"
      [ctrl]="filters.get('rentals')"
      placeholder="Rentals"
    >
    </app-select-search>
  </div>
  <div class="col-auto">
    <app-table-search
      (search)="onSearch($event)"
      [filterGroup]="filterGroup"
      [filterControl]="filters"
    ></app-table-search>
  </div>
  <div class="col-auto ml-auto">
    <button type="button" class="btn btn-success text-uppercase ml-3" (click)="onAdd()" [disabled]="1 | isReadonlyRole">
      <i class="far fa-plus"></i>&nbsp; Add
    </button>
  </div>
</div>
<div class="table-holder table-responsive">
  <table class="table table-default table-striped">
    <mat-table
      #table
      matSort
      matSortActive="name"
      [trackBy]="trackById"
      matSortDirection="asc"
      [dataSource]="dataSource"
    >
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div class="text-truncate" [matTooltip]="element.name" matTooltipPosition="above">{{ element.name }}</div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="type">
        <mat-header-cell *matHeaderCellDef mat-sort-header>type</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.type === 'pct' ? 'Percent' : 'Flat' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="amount">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Amount</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.type === 'pct' ? element.amount + '%' : (element.amount | number: '.2-2') }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="code">
        <mat-header-cell *matHeaderCellDef>Code</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.code }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="rentalView">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Rental</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.rentalView || 'All Rentals' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="startView">
        <mat-header-cell *matHeaderCellDef mat-sort-header="start">Start</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.startView }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="expiresView">
        <mat-header-cell *matHeaderCellDef mat-sort-header="expires">Expires</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.expiresView }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="usedView">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Used</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.usedView }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="leftView">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Left</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.leftView }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Status</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-slide-toggle
            #statusToggle
            [disabled]="1 | isReadonlyRole"
            (click)="$event.stopPropagation()"
            [id]="element.id"
            [checked]="element.status === 1"
            (change)="onStatusChange(element, $event, statusToggle)"
          ></mat-slide-toggle>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef> EDIT </mat-header-cell>

        <mat-cell *matCellDef="let element">
          <div dropdown placement="bottom left" container="body" [isDisabled]="1 | isReadonlyRole">
            <div dropdownToggle (click)="$event.stopPropagation()" class="btn-group btn-ellips-holder">
              <a class="btn-ellips">
                <i class="fas fa-ellipsis-v"></i>
              </a>
            </div>
            <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
              <li>
                <button (click)="onEdit(element)" type="button"><i class="fal fa-edit"></i>Edit</button>
              </li>

              <li
                [matTooltip]="
                  !!element.last_used
                    ? 'Used Discount Code can not be deleted. You can deactivate this code if you do not want to use it anymore'
                    : ''
                "
                matTooltipPosition="left"
              >
                <button (click)="onDelete(element)" type="button" [disabled]="!!element.last_used">
                  <i class="fal fa-trash-alt"></i>Delete
                </button>
              </li>
            </ul>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" (click)="onEdit(row)" class="clickable"></mat-row>
    </mat-table>

    <mat-paginator
      #paginator
      [length]="dataSource?.data?.length"
      [class.hidden]="isEmptyTable$ | async"
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
      [showFirstLastButtons]="true"
    >
    </mat-paginator>

    <app-empty-table *ngIf="isEmptyTable$ | async" [type]="tableType" class="bg-white"></app-empty-table>
  </table>
</div>
